// components/Finanzas.jsx
import React, { useMemo } from "react";

/*
  Props:
    - turnos: array de turnos con posible campo precio (number) y pagado (boolean)
    - senia: number (ej. 5000)
*/
export default function Finanzas({ turnos = [], senia = 5000 }) {
  const stats = useMemo(() => {
    let totalPrecios = 0;
    let totalSeñasEsperadas = 0;
    let señasCobras = 0;
    let ingresosPorSeñas = 0;
    let restanteTotal = 0;

    const porDia = {}; // fecha => { total, count }

    turnos.forEach((t) => {
      const precio = typeof t.precio === "number" ? t.precio : null;
      if (precio) totalPrecios += precio;
      totalSeñasEsperadas += senia;
      if (t.pagado) {
        ingresosPorSeñas += senia;
        señasCobras += 1;
      }
      if (precio) restanteTotal += Math.max(0, precio - (t.pagado ? senia : 0));

      const f = t.fecha || "Sin fecha";
      if (!porDia[f]) porDia[f] = { total: 0, count: 0 };
      porDia[f].total += precio || 0;
      porDia[f].count += 1;
    });

    return {
      totalPrecios,
      totalSeñasEsperadas,
      señasCobras,
      ingresosPorSeñas,
      restanteTotal,
      porDia,
    };
  }, [turnos, senia]);

  return (
    <div className="finanzas-panel">
      <h3>Finanzas rápidas</h3>
      <div className="finanzas-grid">
        <div className="fin-card">
          <small>Total precios (estim.)</small>
          <strong>${stats.totalPrecios.toLocaleString()}</strong>
        </div>

        <div className="fin-card">
          <small>Señas esperadas</small>
          <strong>${stats.totalSeñasEsperadas.toLocaleString()}</strong>
        </div>

        <div className="fin-card">
          <small>Señas cobradas</small>
          <strong>${stats.ingresosPorSeñas.toLocaleString()} ({stats.señasCobras})</strong>
        </div>

        <div className="fin-card">
          <small>Restante total (estim.)</small>
          <strong>${Math.max(0, Math.round(stats.restanteTotal)).toLocaleString()}</strong>
        </div>
      </div>

      <div className="finanzas-por-dia">
        <h4>Resumen por día (muestra primeras 6 fechas)</h4>
        <div className="por-dia-list">
          {Object.entries(stats.porDia)
            .slice(0, 6)
            .map(([fecha, v]) => (
              <div key={fecha} className="por-dia-item">
                <span className="pd-fecha">{fecha}</span>
                <span className="pd-count">{v.count} turnos</span>
                <strong className="pd-total">${v.total.toLocaleString()}</strong>
              </div>
            ))}
          {Object.keys(stats.porDia).length === 0 && <p className="muted">Sin datos</p>}
        </div>
      </div>
    </div>
  );
}
